import React, { FC, memo } from 'react';
import { Slider, SportRouteInComponentProps, navBem } from '@om-fe/widgets';
import { BemModifiersMap } from '@om-fe/core/core/types';
import FavoritesNavItem from '../favorites-nav/favorites-nav-item';
import { FavoritesNavItemsState } from '../favorites/favorites-content';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { FAVORITE_TAB } from '../favorites/favorites-content-tab';
import { ParticipantModel, TournamentModel } from '@om-fe/models';

export interface MixedGroupedMatchListProps extends SportRouteInComponentProps {
    readonly hasOutrightsButton?: boolean;
    readonly activeTab?: string;
    readonly hasArrows?: boolean;
    readonly list: (FavoritesNavItemsState | ParticipantModel | TournamentModel)[];
    readonly favoriteEvent?: number;
}

export const FavoritesNav: FC<MixedGroupedMatchListProps> = memo((
    {
        activeTab,
        hasArrows,
        list,
        onRouteChange,
        favoriteEvent,
    }: MixedGroupedMatchListProps,
) => {
    const { gettext } = useI18NContext();
    const favoritesList: React.ReactNode[] = [];
    if (favoriteEvent !== 0) {
        favoritesList.push(
            <FavoritesNavItem
                list={{
                    shortTranslatedName: gettext('My Event')
                }}
                id={FAVORITE_TAB.EVENT}
                activeTab={activeTab}
                onRouteChange={onRouteChange}
            />
        );
    }

    Object.keys(list).length > 0 && Object.keys(list).map((item) => {
            favoritesList.push(
                <FavoritesNavItem
                    list={list[item]}
                    id={item}
                    activeTab={activeTab}
                    onRouteChange={onRouteChange}
                />
            );
    });

    const modifiers: BemModifiersMap = {
        FavoritesNav: true,
        ItemToStartUnequalWidth: true,
        Small10: true,
        Tertiary: true,
    };

    return (
        <div className={navBem()}>
            <Slider
                sliderItems={favoritesList}
                modifiersFromParent={modifiers}
                hasArrows={hasArrows && Object.keys(list).length > 0}
            />
        </div>
    );
});
